import { useI18n } from '../i18n';
import ShareBar from './ShareBar';
import type { GameState } from '../lib/useGuessGame';
import CountryAnswerCard from './CountryAnswerCard';

// 一局结束横幅:daily 显示成绩 + 分享;unlimited 显示「下一个」+(猜中时)分享(含 Best)
export default function EndBanner({ mode, g }: { mode: string; g: GameState }) {
  const { t } = useI18n();
  const a = g.answer;
  const won = g.status === 'won';

  if (g.endless) {
    return (
      <div className={`banner ${won ? 'win' : 'revealed'}`}>
        {won && <h2>{t.won}</h2>}
        <CountryAnswerCard country={a} />
        <div className="round-actions">
          <button className="share-trigger" onClick={g.next}>
            {t.nextCountry} →
          </button>
          {won && (
            <ShareBar
              mode={mode}
              num={g.num}
              guesses={g.guesses}
              answer={a}
              streak={g.streak}
              endless
              best={g.best}
            />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`banner ${won ? 'win' : 'lose'}`}>
      <h2>{won ? t.won : t.lost}</h2>
      {won && <div className="banner-score">{g.guesses.length}/∞</div>}
      <CountryAnswerCard country={a} />
      <ShareBar mode={mode} num={g.num} guesses={g.guesses} answer={a} streak={g.streak} />
    </div>
  );
}
